import React, { useEffect, useState } from 'react';
import bonusService from '../services/bonusService';
import { useTranslation } from 'react-i18next';

export default function BonusLine() {
  const { t } = useTranslation();
  const [bonuses, setBonuses] = useState([]);

  useEffect(() => {
    const fetchBonuses = async () => {
      try {
        const data = await bonusService.getUserBonuses();
        // Assuming response shape { success, bonuses: [] }
        setBonuses(data.bonuses || []);
      } catch (e) {
        console.error('Failed to fetch bonuses', e);
      }
    };
    fetchBonuses();
  }, []);

  if (!bonuses.length) return null;

  return (
    <div className="flex flex-wrap gap-4 py-2 bg-slate-900/30 rounded-xl border border-slate-800">
      {bonuses.map((b) => (
        <div key={b.id} className="flex items-center bg-slate-800/50 px-3 py-1 rounded-md">
          <span className="text-sm text-slate-200 mr-2">{b.title}</span>
          <span className={`text-xs font-medium ${b.status === 'completed' ? 'text-emerald-400' : 'text-amber-400'}`}>{b.status}</span>
        </div>
      ))}
    </div>
  );
}
